// extracted by mini-css-extract-plugin
module.exports = {"pieButton":"PieButton_pieButton__2RcN6","value":"PieButton_value__1QA9b","value2":"PieButton_value2__1hbDT","background":"PieButton_background__1EGjd"};